function htmlToNode(htmlString) {
  var div = document.createElement("div");
  div.innerHTML = htmlString.trim();

  return div.firstChild;
}

export default htmlToNode;



// WEBPACK FOOTER //
// ./ressources/src/js/util/htmlToNode.js